/**
 * Filter search results by Top Doctors/Dentists only
 */
const init = () => {
	const topDocInput = document.querySelector('.top-doctors-only__input');

	// bail if no filter area
	if (!topDocInput) {
		return;
	}

	/**
	 * Update the url
	 *
	 * @param {object} event Event object.
	 */
	function updateURL(event) {
		if (typeof event.target.value !== 'undefined') {
			window.location.replace(event.target.value);
		}
	}

	topDocInput.addEventListener('change', updateURL);
};

init();
